import { createContainer, createHook, createStore } from 'react-sweet-state';

import { actions } from './actions';
import { initialState } from './state';
import { type ResponderNamesState } from './state/types';
import { type ContainerProps } from './types';

export const ResponderNamesStore = createStore<ResponderNamesState, typeof actions>({
	initialState: initialState,
	actions,
	name: 'ResponderNamesStore',
});

export const ResponderNamesContainer = createContainer<
	ResponderNamesState,
	typeof actions,
	ContainerProps
>(ResponderNamesStore);

export const useResponderNamesStore = createHook<ResponderNamesState, typeof actions>(
	ResponderNamesStore,
);
